// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"rp","title":"rq","notSelected":"rr","duration":"rs","image":"rt","infoWrapper":"ru","description":"rv"};